import { createSlice } from '@reduxjs/toolkit';
import { INewbuildingRecommendationsState } from '../../types/recommendations';

export const initialState: INewbuildingRecommendationsState = {
  allRecommendationsUrl: '',
  compilations: [],
  modelVersion: '',
  newbuildings: [],
};

export const newbuildingRecommendationsSlice = createSlice({
  name: 'newbuildingRecommendations',
  initialState,
  reducers: {},
});

export const { reducer: newbuildingRecommendationsReducer } = newbuildingRecommendationsSlice;
